import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countrie from '../countrie/countrie';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from 'react-router-dom';

const FormulaireInscriptionEnLigne = () => {
  const history = useHistory();

  const [formData, setFormData] = useState({
    civilite: '',
    prenom: '',
    nom: '',
    telephone: '',
    email: '',
    postOccupe: '',
    organisme: '',
    pays: '',
    modeFormation: '',
    theme: '',
    typeFormation: '',
    formationNom: '',
    dateDebut: '',
    dateFin: '',
    nombrePersonnes: '',
    message: '',
    lieu: '',
  });

  const [errors, setErrors] = useState({});
  const [displayCatalogue, setDisplayCatalogue] = useState(true);
  const [displaySurMesure, setDisplaySurMesure] = useState(false);
  const [formations, setFormations] = useState([]);
  const [typesFormation, setTypesFormation] = useState([]);
  const Url = process.env.REACT_APP_URL_DEV;

  const recaptchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${Url}/api/formation/formations`)
      .then((res) => {
        const data = res.data.data;
        if (data && typeof data === 'object') setFormations(data);
      })
      .catch(console.error);
  }, [Url]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'formationNom') {
      const selected = Object.values(formations)
        .flat()
        .find((f) => f.formationCode === value);
      if (selected) {
        setTypesFormation(
          selected.formationType.split(/\s*,\s*/).map((t) => t.trim()),
        );
      } else {
        setTypesFormation([]);
      }
    }

    if (successMessage) setSuccessMessage('');
  };

  const handleCatalogueClick = () => {
    setDisplayCatalogue(true);
    setDisplaySurMesure(false);
    setFormData((prev) => ({
      ...prev,
      modeFormation: 'Sur Catalogue',
      theme: '',
      dateDebut: '',
      dateFin: '',
      nombrePersonnes: '',
      lieu: '',
      typeFormation: '',
      formationNom: '',
    }));
    setTypesFormation([]);
    if (successMessage) setSuccessMessage('');
  };

  const handleSurMesureClick = () => {
    setDisplayCatalogue(false);
    setDisplaySurMesure(true);
    setFormData((prev) => ({
      ...prev,
      modeFormation: 'Sur Mesure',
      formationNom: '',
      typeFormation: '',
      theme: '',
      dateDebut: '',
      dateFin: '',
      nombrePersonnes: '',
      lieu: '',
    }));
    setTypesFormation([]);
    if (successMessage) setSuccessMessage('');
  };

  const validateForm = () => {
    const newErrors = {};
    const required = [
      'civilite',
      'prenom',
      'nom',
      'telephone',
      'email',
      'postOccupe',
      'organisme',
      'pays',
      'modeFormation',
    ];
    required.forEach((f) => {
      if (!formData[f]) newErrors[f] = 'Ce champ est obligatoire.';
    });

    if (formData.modeFormation === 'Sur Catalogue') {
      if (!formData.formationNom)
        newErrors.formationNom = 'Ce champ est obligatoire.';
      if (!formData.typeFormation)
        newErrors.typeFormation = 'Ce champ est obligatoire.';
    }
    if (formData.modeFormation === 'Sur Mesure') {
      if (!formData.theme) newErrors.theme = 'Ce champ est obligatoire.';
      if (!formData.dateDebut)
        newErrors.dateDebut = 'Ce champ est obligatoire.';
      if (!formData.dateFin) newErrors.dateFin = 'Ce champ est obligatoire.';
      if (!formData.nombrePersonnes)
        newErrors.nombrePersonnes = 'Ce champ est obligatoire.';
      if (!formData.lieu) newErrors.lieu = 'Ce champ est obligatoire.';
      if (!formData.typeFormation)
        newErrors.typeFormation = 'Ce champ est obligatoire.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    if (successMessage) setSuccessMessage('');
    if (errors.captcha) setErrors((prev) => ({ ...prev, captcha: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    axios
      .post(`${Url}/api/form/Inscription`, {
        ...formData,
        'g-recaptcha-response': captchaToken || '',
      })
      .then(() => {
        setSuccessMessage('Formulaire soumis avec succès !');
        recaptchaRef.current.reset();
        setCaptchaToken(null);
        setFormData({
          civilite: '',
          prenom: '',
          nom: '',
          telephone: '',
          email: '',
          postOccupe: '',
          organisme: '',
          pays: '',
          modeFormation: '',
          theme: '',
          typeFormation: '',
          formationNom: '',
          dateDebut: '',
          dateFin: '',
          nombrePersonnes: '',
          message: '',
          lieu: '',
        });
        setTypesFormation([]);
        setDisplayCatalogue(true);
        setDisplaySurMesure(false);
        setErrors({});
      })
      .catch(() => {
        alert('Erreur lors de l’envoi.');
      })
      .finally(() => setLoading(false));
  };

  // Style pour inputs et selects compacts
  const inputStyle = {
    height: '40px',
    fontSize: '14px',
    marginBottom: '10px',
  };

  return (
    <div>
      <div
        className="d-flex justify-content-center mt-3"
        style={{ margin: '20px' }}
      >
        <button
          type="button"
          className="btn-catalogue"
          onClick={() => history.push('/')}
        >
          ← Retour à l&apos;accueil
        </button>
      </div>

      <div
        style={{
          backgroundImage:
            "url('/assets/img/institute/Finances-publiques-et-Bonne-Gouvernance.webp')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <h1
            style={{
              color: '#fff',
              fontSize: '2rem',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Inscription en Ligne
          </h1>
        </div>
      </div>

      <div
        className="inscription-form-container mt-5"
        style={{
          maxWidth: '700px',
          margin: '0 auto',
          padding: '20px',
          backgroundColor: '#fff',
          borderRadius: '10px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        }}
      >
        <form className="inscription-form" onSubmit={handleSubmit}>
          {/* Civilité */}
          <div className="form-group">
            <label>Civilité *</label>
            <select
              name="civilite"
              value={formData.civilite}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="">Civilité</option>
              <option value="M.">M.</option>
              <option value="Mme">Mme</option>
            </select>
            {errors.civilite && <p className="error">{errors.civilite}</p>}
          </div>

          {/* Prénom et Nom */}
          <div className="row">
            <div className="form-group col-12 col-sm-6">
              <label>Prénom *</label>
              <input
                type="text"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.prenom && <p className="error">{errors.prenom}</p>}
            </div>
            <div className="form-group col-12 col-sm-6">
              <label>Nom *</label>
              <input
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.nom && <p className="error">{errors.nom}</p>}
            </div>
          </div>

          {/* Téléphone et Email */}
          <div className="row">
            <div className="form-group col-12 col-sm-6">
              <label>Téléphone *</label>
              <PhoneInput
                country={'tn'}
                value={formData.telephone}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, telephone: value }))
                }
                inputStyle={{ width: '100%', height: '40px' }}
              />
              {errors.telephone && <p className="error">{errors.telephone}</p>}
            </div>
            <div className="form-group col-12 col-sm-6">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
          </div>

          {/* Poste Occupé */}
          <div className="form-group">
            <label>Poste Occupé *</label>
            <input
              type="text"
              name="postOccupe"
              value={formData.postOccupe}
              onChange={handleChange}
              style={inputStyle}
            />
            {errors.postOccupe && <p className="error">{errors.postOccupe}</p>}
          </div>

          {/* Organisme */}
          <div className="form-group">
            <label>Organisme *</label>
            <input
              type="text"
              name="organisme"
              value={formData.organisme}
              onChange={handleChange}
              style={inputStyle}
            />
            {errors.organisme && <p className="error">{errors.organisme}</p>}
          </div>

          {/* Pays */}
          <div className="form-group">
            <label>Pays *</label>
            <select
              name="pays"
              value={formData.pays}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="">-- Sélectionnez votre pays --</option>
              {countrie.map((c, idx) => (
                <option key={idx} value={c}>
                  {c}
                </option>
              ))}
            </select>
            {errors.pays && <p className="error">{errors.pays}</p>}
          </div>

          {/* Mode de formation */}
          <div className="form-group">
            <label>Mode de formation *</label>
            <div className="d-flex justify-content-center mt-2">
              <button
                type="button"
                className={`btn-catalogue ${
                  formData.modeFormation === 'Sur Catalogue' ? 'active' : ''
                } mx-2`}
                onClick={handleCatalogueClick}
                style={{ padding: '5px 15px', fontSize: '14px' }}
              >
                Sur Catalogue
              </button>
              <button
                type="button"
                className={`btn-sur-mesure ${
                  formData.modeFormation === 'Sur Mesure' ? 'active' : ''
                } mx-2`}
                onClick={handleSurMesureClick}
                style={{ padding: '5px 15px', fontSize: '14px' }}
              >
                Sur Mesure
              </button>
            </div>
          </div>

          {displayCatalogue && (
            <div className="form-group">
              <label>Formation *</label>
              <select
                name="formationNom"
                value={formData.formationNom}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">-- Sélectionnez une formation --</option>
                {Object.entries(formations).map(([domaineNom, list]) => (
                  <optgroup key={domaineNom} label={domaineNom}>
                    {list.map((f, idx) => (
                      <option key={idx} value={f.formationCode}>
                        {f.formationNom}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
              {errors.formationNom && (
                <p className="error">{errors.formationNom}</p>
              )}

              <select
                name="typeFormation"
                value={formData.typeFormation}
                onChange={handleChange}
              >
                <option value="">-- Type de formation --</option>
                {typesFormation.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>

              {errors.typeFormation && (
                <p className="error">{errors.typeFormation}</p>
              )}
            </div>
          )}

          {displaySurMesure && (
            <div className="form-group">
              <label>Thème *</label>
              <input
                type="text"
                name="theme"
                value={formData.theme}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.theme && <p className="error">{errors.theme}</p>}

              <label>Date début *</label>
              <input
                type="date"
                name="dateDebut"
                value={formData.dateDebut}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.dateDebut && <p className="error">{errors.dateDebut}</p>}

              <label>Date fin *</label>
              <input
                type="date"
                name="dateFin"
                value={formData.dateFin}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.dateFin && <p className="error">{errors.dateFin}</p>}

              <label>Nombre de personnes *</label>
              <input
                type="number"
                name="nombrePersonnes"
                value={formData.nombrePersonnes}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.nombrePersonnes && (
                <p className="error">{errors.nombrePersonnes}</p>
              )}

              {/* Lieu */}
              <label>Lieu *</label>
              <select
                name="lieu"
                value={formData.lieu}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">-- Sélectionnez un lieu --</option>
                <option value="Tunis - Tunisie">Tunis - Tunisie</option>
                <option value="Casablanca - Maroc">Casablanca - Maroc</option>
                <option value="Dubai - UAE">Dubai - UAE</option>
              </select>
              {errors.lieu && <p className="error">{errors.lieu}</p>}

              <label>Type de formation *</label>
              <select
                name="typeFormation"
                value={formData.typeFormation}
                onChange={handleChange}
              >
                <option value="">-- Choisissez une option --</option>

                <option value="Présentiel">Présentiel</option>
                <option value="En ligne">En ligne</option>

                {typesFormation.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>

              {errors.typeFormation && (
                <p className="error">{errors.typeFormation}</p>
              )}
            </div>
          )}

          {/* Message */}
          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              style={{ ...inputStyle, height: '80px' }}
            />
          </div>

          {/* Captcha */}
          <div style={{ margin: '20px 0', textAlign: 'center' }}>
            <ReCAPTCHA
              sitekey="6Lf8vqIrAAAAAJSU8cRjXvxEO3864ewH_Np9j9I_"
              ref={recaptchaRef}
              onChange={handleCaptchaChange}
            />
          </div>

          <div className="col-12" style={{ textAlign: 'center' }}>
            <button
              type="submit"
              disabled={loading}
              style={{ padding: '10px 20px', fontSize: '16px' }}
            >
              {loading ? 'Envoi...' : 'Envoyer'}
            </button>
            {successMessage && (
              <p style={{ color: 'green', marginTop: '10px' }}>
                {successMessage}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormulaireInscriptionEnLigne;
